const Loading = () => (
  <>
    <rect
      opacity="0.5"
      x="11"
      y="15"
      width="2"
      height="7"
      rx="1"
    />
    <rect
      opacity="0.25"
      x="13.4141"
      y="14.8281"
      width="2"
      height="7"
      rx="1"
      transform="rotate(-45 13.4141 14.8281)"
    />
    <rect
      x="2"
      y="13"
      width="2"
      height="7"
      rx="1"
      transform="rotate(-90 2 13)"
    />
    <rect
      opacity="0.75"
      x="5.63672"
      y="19.7812"
      width="2"
      height="7"
      rx="1"
      transform="rotate(-135 5.63672 19.7812)"
    />
  </>
);

export default Loading;
